import { render, staticRenderFns } from "./change-expansion-card-modal.vue?vue&type=template&id=bd10aa84&scoped=true&lang=pug&"
import script from "./change-expansion-card-modal.vue?vue&type=script&lang=js&"
export * from "./change-expansion-card-modal.vue?vue&type=script&lang=js&"
import style0 from "./change-expansion-card-modal.vue?vue&type=style&index=0&id=bd10aa84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd10aa84",
  null
  
)

export default component.exports